export default "__VITE_ASSET__8O29nvSh__"